import { api } from './api';

export interface SeedStatus {
  present: boolean;
  accounts: number;
  contacts: number;
  signals: number;
  total: number;
}

export interface SeedLoadResult extends SeedStatus {
  seeded: boolean;
}

export interface SeedClearResult {
  cleared: boolean;
  deleted: { accounts: number; contacts: number; signals: number; sequences: number };
}

/** Sample-data ("first-contact" seed) controls — load, status, clear. */
export const seedApi = {
  status: async (workspaceId: string): Promise<SeedStatus> => {
    const r = await api.get<SeedStatus>(`/api/workspaces/${workspaceId}/seed/status`);
    return r.data;
  },
  load: async (workspaceId: string): Promise<SeedLoadResult> => {
    const r = await api.post<SeedLoadResult>(`/api/workspaces/${workspaceId}/seed/demo`);
    return r.data;
  },
  clear: async (workspaceId: string): Promise<SeedClearResult> => {
    const r = await api.delete<SeedClearResult>(`/api/workspaces/${workspaceId}/seed/demo`);
    return r.data;
  },
};
